import React, {useEffect, useState} from "react";
import {useIsMobile} from "../../hooks/useIsMobile";
import AddGoods from "./AddGoods";
import {deletePostCard, getMypagePostCardList, getPostCard, updatePostCardText} from "../../api/index";


const AddGoodsContainer = () => {

    const isMobile = useIsMobile();
    const [postCardList, setPostCardList] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState(4);
    const [totalPages, setTotalPages] = useState<number>(1);

    const getData = async() => {
        const data = await getMypagePostCardList(currentPage, itemsPerPage);
        setPostCardList(data);
        setTotalPages(data.totalPages);
    }


    useEffect(() => {

        getData();
    }, [currentPage, itemsPerPage])


    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };



    const  deletePost =  async (id: number) => {
        const data = await deletePostCard(id);
    }


    const saveText = async(id : number, msg:string) => {

        await updatePostCardText(id, msg);
        await getData();
    }


    return(
    <>
        <AddGoods isMobile={isMobile} postCardList={postCardList} onDelete={deletePost} onUpdate={saveText} currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}/>
    </>

    )
}

export default AddGoodsContainer;
